import ActiveController from "rapid/controller";
import {getAttachmentFontFamily} from "../../../utility/font-face.helper";
import {
    clampOutputPosition,
    getOutputBox,
    moveOutput,
    snapToGuides,
    getBoxGuides
} from "../../../constants/individual-text.constant";

// Snap distance in px of the preview
const SNAP_DISTANCE = 6;
const VERTICAL_ALIGN = {top: "flex-start", center: "center", bottom: "flex-end"};

export class individualTextOutputPreviewController extends ActiveController {
    constructor($injector, $element, $scope) {
        "ngInject";
        super($injector);

        this.$element = $element;
        this.$scope = $scope;
        this.measureContext = document.createElement("canvas").getContext("2d");
        this.onFontLoad = () => this.$scope.$applyAsync();
        this.guides = {x: [], y: []};
    }

    getScale() {
        return Number(this.index) || 1;
    }

    /** Places the text layer exactly over html-preview's rendered layout. */
    getLayerStyle() {
        const wrapper = this.$element[0].querySelector(".individual-text-output");
        const layout = this.$element[0].querySelector(".preview-main");
        const scale = this.getScale();
        let left = 0;
        let top = 0;
        if (wrapper && layout) {
            const wrapperRect = wrapper.getBoundingClientRect();
            const layoutRect = layout.getBoundingClientRect();
            left = layoutRect.left - wrapperRect.left + layout.clientLeft;
            top = layoutRect.top - wrapperRect.top + layout.clientTop;
        }
        return {
            left: left + "px",
            top: top + "px",
            width: this.canvasWidth / scale + "px",
            height: this.canvasHeight / scale + "px"
        };
    }

    /** Without a text the field name stands in, so the position can still be set. */
    getText(field) {
        return field.output.text || field.label.text;
    }

    getFontFamily(field) {
        const family = getAttachmentFontFamily(field.font, this.onFontLoad);
        return family ? `"${family}", sans-serif` : "sans-serif";
    }

    /** Shrinks the font between fontSize and minFontSize so the text fits the box width. */
    getFittedFontSize(field) {
        const output = field.output;
        this.measureContext.font = `${output.fontSize}px ${this.getFontFamily(field)}`;
        const width = this.measureContext.measureText(this.getText(field)).width;
        const boxWidth = output.width * this.canvasWidth / 100;
        if (!width || width <= boxWidth) {
            return output.fontSize;
        }
        return Math.max(output.minFontSize, output.fontSize * boxWidth / width);
    }

    getTextStyle(field) {
        const output = field.output;
        const scale = this.getScale();
        const box = getOutputBox(output, this.canvasWidth, this.canvasHeight);
        return {
            left: box.left / scale + "px",
            top: box.top / scale + "px",
            width: box.width / scale + "px",
            height: box.height / scale + "px",
            justifyContent: VERTICAL_ALIGN[output.verticalAlign] || VERTICAL_ALIGN.top,
            fontSize: this.getFittedFontSize(field) / scale + "px",
            fontFamily: this.getFontFamily(field),
            color: output.color,
            textAlign: output.align
        };
    }

    getGuideStyle(axis, value) {
        return axis === "x" ? {left: value / this.getScale() + "px"} : {top: value / this.getScale() + "px"};
    }

    onDrag(field, phase, dx, dy) {
        if (!this.editable) {
            return;
        }
        if (phase === "start") {
            this.dragStart = getOutputBox(field.output, this.canvasWidth, this.canvasHeight);
            return;
        }
        if (phase === "end") {
            this.guides = {x: [], y: []};
            return;
        }
        const output = field.output;
        const scale = this.getScale();
        const guides = {
            x: [0, this.canvasWidth / 2, this.canvasWidth],
            y: [0, this.canvasHeight / 2, this.canvasHeight]
        };
        this.settings.fields.filter((other) => other.enabled && other !== field).forEach((other) => {
            const box = getOutputBox(other.output, this.canvasWidth, this.canvasHeight);
            guides.x.push(...getBoxGuides(box.left, box.width));
            guides.y.push(...getBoxGuides(box.top, box.height));
        });
        const start = this.dragStart;
        const snapX = snapToGuides(start.left + dx * scale, start.width, guides.x, SNAP_DISTANCE * scale);
        const snapY = snapToGuides(start.top + dy * scale, start.height, guides.y, SNAP_DISTANCE * scale);
        moveOutput(output, snapX.start, snapY.start, this.canvasWidth, this.canvasHeight);
        clampOutputPosition(output, this.canvasWidth, this.canvasHeight);
        this.guides = {
            x: snapX.guide === null ? [] : [snapX.guide],
            y: snapY.guide === null ? [] : [snapY.guide]
        };
    }
}



// WEBPACK FOOTER //
// ./sources/components/common/individual-text-output-preview/individual-text-output-preview.controller.js